import { render, staticRenderFns } from "./TrackingNumber.vue?vue&type=template&id=78a1ae5d&"
import script from "./TrackingNumber.vue?vue&type=script&lang=ts&"
export * from "./TrackingNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports